








































import Vue from 'vue'
import SlackService from 'amazing-toolkit/dist/SlackService'
SlackService.init('https://hooks.slack.com/services/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')
require('../assets/js/crisp')
var pjson = require('../../package.json')
export default Vue.extend({
  name: 'Uninstall',
  data () {
    return {
    }
  },
  mounted () {
    this.notifySlack(this.$route.query.uid, this.$route.query.browser, this.$route.query.version)
  },
  methods: {
    async notifySlack (uid:any = 'sanyam', browser:any = 'web', version = pjson.version) {
      await SlackService.postToSlack({
        text: `uninstall: ${uid}-${browser}-${version}`
      })
    }
  }
})
